import * as Sentry from '@sentry/react'

const appVersion = process.env.REACT_APP_VERSION || 'unknown'

type LogData = Record<string, unknown>
type LogErrorData = LogData & { error: unknown }

export const logService = {
  error(message: string, info: LogErrorData) {
    if (info.error instanceof Error) {
      Sentry.captureException(info.error)
    } else {
      const data = { ...info, version: appVersion }
      Sentry.logger.error(message, { data })
    }
  },
  info(message: string, info?: LogData) {
    const data = { ...info, version: appVersion }
    Sentry.logger.info(message, { data })
  },
  warning(message: string, info?: LogData) {
    const data = { ...info, version: appVersion }
    Sentry.logger.warn(message, { data })
  },
}
